export const SHOP_STEPS = {
  PAYMENT: 'PAYMENT',
  CUSTOMER: 'CUSTOMER',
  MAIN_PRODUCT: 'MAIN_PRODUCT',
  ACCESSORIES: 'ACCESSORIES',
  CREDIT_CHECK: 'CREDIT_CHECK',
  FRAME_AGREEMENT: 'FRAME_AGREEMENT',
  CONTRACT: 'CONTRACT',
  CONFIRM: 'CONFIRM',
}

export const PAYMENT_TYPES = {
  BUY: 'BUY',
  LEASE: 'LEASE',
}

export const PRODUCT_TYPES = {
  PC: 'PC',
  MOBILE_PHONE: 'MOBILE_PHONE',
  MONITOR: 'SCREEN',
  TABLET: 'TABLET',
  SOFTWARE: 'SOFTWARE',
  DOCKING: 'DOCKING',
  SERVICE: 'SERVICE',
  ACCESSORY: 'OTHER',
}

export const CREDIT_CHECK_TYPES = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  MANUAL: 'MANUAL',
  ERROR: 'ERROR',
}
